import { FeatureConfig } from '@typesApp/Config'

const baseFeatureConfig_CA: FeatureConfig = {
  disableInsuranceMemberEligibilityCheck: true,
}

const BrandFeatureConfig = {
  ebd: {
    disableAuthTokenSessionIdCheck: true,
    contactUs: ['phone', 'faq'],
  },
  fde: {
    contactUs: ['phone', 'faq'],
  },
  nua: {
    disableInsuranceToggleMessages: true,
  },
  cle: {
    ...baseFeatureConfig_CA,
    allowWCTokensWithoutSessionId: true,
  },
  lcr: {
    ...baseFeatureConfig_CA,
  },
  vde: {
    ...baseFeatureConfig_CA,
    validateInsurerEligibleProduct: true,
  },
} as Record<string, FeatureConfig>

const EnvBrandFeatureConfig = {
  STAGE: {
    vde: {
      ...BrandFeatureConfig['vde'],
      disableStrictSSNValidation: true,
    },
  },
} as Record<string, Record<string, FeatureConfig>>

export const featureConfig = {
  DEV: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['DEV'],
  },
  TEST: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['TEST'],
  },
  STAGE: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['STAGE'],
  },
  PROD: {
    ...BrandFeatureConfig,
    ...EnvBrandFeatureConfig['PROD'],
  },
} as Record<'DEV' | 'TEST' | 'STAGE' | 'PROD', FeatureConfig>
